import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AutomaticMapping } from '../models/generated/ziroModels';

@Injectable()
export class MicrosoftCucmAutomaticMappingResource {
  private _http = inject(HttpClient);

  get(tenantId: number, exportId: string): Observable<AutomaticMapping> {
    return this._http.get<AutomaticMapping>(
      `/services/microsoft/migrations/tenants/${tenantId}/exports/cisco/${exportId}/number-report/automatic-mapping`,
    );
  }

  put(tenantId: number, exportId: string, automaticMapping: AutomaticMapping): Observable<void> {
    return this._http.put<void>(
      `/services/microsoft/migrations/tenants/${tenantId}/exports/cisco/${exportId}/number-report/automatic-mapping`,
      automaticMapping,
    );
  }
}
